import {AfterViewInit, Component, ElementRef, EventEmitter, Input, Output} from '@angular/core';

import {GetSaseungTxt} from 'src/app/shared/defines/gukeo.func';
import {Saseung, SaseungHanja} from "../../shared/models/saseung.model";

export type SASEUNG_ITEM_VIEW_INIT = {
  hanja?: SaseungHanja;
  elementRef: ElementRef;
}

@Component({
  selector: 'app-saseung-item',
  templateUrl: './saseung-item.component.html',
  styleUrls: ['./saseung-item.component.scss']
})
export class SaseungItemComponent implements AfterViewInit {
  @Input() hanja?: SaseungHanja;
  @Input() hangul: string | null = null;
  @Input() selected: string | null = null;
  @Output() viewInit = new EventEmitter<SASEUNG_ITEM_VIEW_INIT>();

  constructor(
    private elementRef: ElementRef,
  ) {
  }

  ngAfterViewInit() {
    this.viewInit.emit({
      hanja: this.hanja,
      elementRef: this.elementRef,
    });
  }

  public GetSaseungTxt(symbol: string): string {
    const saseungTxt = GetSaseungTxt(symbol);
    if (!saseungTxt) {
      console.error('SaseungDetailComponent::GetSaseungTxt() invalid saseung symbol', symbol);
    }
    return saseungTxt ? saseungTxt : '';
  }


  /**
   * 사성에서 지정된 한글의 사성만 추린다. 고객의 요청으로 필터링함.
   * 일부러 이렇게 한 것이다. 걸러내지 않는 것이 더 좋은 것 같은데...
   * TODO: 나중에 다시 넣을 수 있다고 생각한다.
   *
   * @param hangul
   * @param saseungs
   * @protected
   */
  protected getSasaeung(saseungs: Array<Saseung>): Array<Saseung> {
    return this.hangul ? saseungs.filter((saseung: Saseung) => saseung.hangul === this.hangul) : saseungs;
  }
}
